<template>
    <list-widget title="검색결과">
        <b class="mr-1"> {{ summary.totalCount?.format?.() }} </b> 건
    </list-widget>
</template>

<script>
import ListWidget from "./list-widget.vue";
export default {
    components: {
        ListWidget,
    },
    props: {
        summary: { type: Object, default: () => ({ totalCount: 0 }) },
    },
};
</script>

<style></style>
